<section *ngIf="!isOpened">
    <div class="row">
        <div class="col-12 col-sm-12">
            <form class="needs-validation container-style" novalidate [formGroup]="formCompositeArticle">
                <div class="ps-2 pe-2">
                    <div class="row pt-1">
                        <div class="col">
                            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true"
                                [label]="'Regresar'" [width]="'6rem'" [routerLink]="['/', url]"
                                [severity]="null"></app-custom-button>
                        </div>
                        <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
                            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
                        </div>
                        <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
                            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                                (onClick)="deleteCompositeArticle()"></app-custom-button>
                            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                                (onClick)="createNewRegister()"></app-custom-button>
                        </div>
                        <hr class="my-1">
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                            <app-custom-audit-info [userNameCreate]="compositeArticleContract.userNameCreate"
                                [createDate]="compositeArticleContract.createDate"
                                [userNameUpdate]="compositeArticleContract.userNameUpdate"
                                [updateDate]="compositeArticleContract.updateDate" [reserveSpace]="true">
                            </app-custom-audit-info>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7 col-12">
                        <div class="row d-flex align-items-start">
                            <div class="col-lg-2 col-md-3 col-sm-3 col-12">
                                <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true"
                                    [recovery]="true" (onChangeNumber)="changeCode($event)"></app-custom-input-number>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                                <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                                    [maxLength]="20"></app-custom-input-text>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                                <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno2'"
                                    [maxLength]="20"></app-custom-input-text>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-10">
                                <app-custom-tag [label]="'Estado'" [severity]="severityState"
                                    [value]="stateCompositeArticle">
                                </app-custom-tag>
                            </div>
                            <div class="col field-button">
                                <app-custom-button [title]="titleState" [icon]="iconState" [severity]="'primary'"
                                    (onClick)="changeState()">
                                </app-custom-button>
                            </div>
                            <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                                <app-custom-textarea formControlName="name" [labelText]="'Nombre'" [autoResize]="false"
                                    [required]="true" [rows]="1" [maxLength]="300"></app-custom-textarea>
                            </div>
                            <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                                <app-custom-textarea formControlName="observation" [labelText]="'Observacion'"
                                    [autoResize]="false" [required]="false" [rows]="1"
                                    [maxLength]="1000"></app-custom-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-12">
                        <div class="row d-flex align-items-start">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                                <app-custom-autocomplete formControlName="familyId" [labelText]="'Familia'"
                                    [list]="listFamily" [required]="true">
                                </app-custom-autocomplete>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                                <app-custom-autocomplete formControlName="subgroupId" [labelText]="'Subgrupo'"
                                    [list]="listSubgroup" [required]="true" (onChangeSelect)="getSubgroup($event)">
                                </app-custom-autocomplete>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                                <app-custom-autocomplete formControlName="groupId" [labelText]="'Grupo'"
                                    [list]="listGroup" [required]="true" (onChangeSelect)="getSubgroup($event)">
                                </app-custom-autocomplete>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12 d-flex justify-content-end mt-3">
                                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'"
                                    [variant]="undefined" [disabled]="!permissionUpdatable" (onClick)="send()">
                                </app-custom-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-composite-article-detail [compositeArticleModel]="compositeArticleContract"
            [permissionUpdatable]="permissionUpdatable" (emitQuantityDetails)="quantityDetails = $event">
        </app-composite-article-detail>
    </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
    <span class="material-icons me-1"> highlight_off </span>
    <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>